import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AddReligion } from "../../actions/religionSetting";
import Spinner from "../layout/Spinner";

const AddReligionDetails = ({
  savedMessage,
  auth: { isAuthenticated, user, users, loading },
  AddReligion,
  setShowAddReligionModal,
}) => {
  //formData
  const [formData, setFormData] = useState({
    religionName: "",
    isSubmitted: false,
  });
  const { religionName } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      religionName: religionName,
      religionEnteredById: user._id,
      religionEnteredByName: user.userName,
      institutionId: user.institutionId,
      userData: user,
    };
    AddReligion(finalData);
    setShowAddReligionModal(false);
    setFormData({
      ...formData,
      religionName: "",

      isSubmitted: true,
    });
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align">
        <form className="row" onSubmit={(e) => onSubmit(e)} autoComplete="off">
          <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="col-lg-10 col-md-12 col-sm-12 col-12">
              <label className="label-control"> Religion Name* :</label>
              <input
                type="text"
                name="religionName"
                value={religionName}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                required
              />
            </div>
          </div>

          <div className="col-md-10 col-lg-10 col-sm-12 col-12 text-left">
            {loading ? (
              <button
                className="btn sub_form btn_continue Save float-right"
                disabled
              >
                Loading...
              </button>
            ) : (
              <input
                type="submit"
                name="Save"
                value="Submit"
                className="btn sub_form btn_continue Save float-right"
              />
            )}
          </div>
        </form>
      </div>
    </Fragment>
  );
};

AddReligionDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  religionSetting: PropTypes.object.isRequired,
  AddReligion: PropTypes.func.isRequired,
  savedMessage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  savedMessage: state.auth.savedMessage,
  religionSetting: state.religionSetting,
});

export default connect(mapStateToProps, {
  AddReligion,
})(AddReligionDetails);
